class WebSocketService {
  constructor() {
    this.socket = null;
    this.listeners = [];
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.username = null;
  }

  connect(username) {
    this.username = username;
    
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      console.log('⚠️ WebSocket уже подключен');
      return;
    }

    try {
      const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      const wsUrl = `${protocol}//${window.location.host}/ws?username=${username}`;
      console.log('🔌 Подключение к WebSocket:', wsUrl);
      
      this.socket = new WebSocket(wsUrl);
      
      this.socket.onopen = () => {
        console.log('✅ WebSocket подключен');
        this.reconnectAttempts = 0;
      };

      this.socket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          console.log('📩 Получено сообщение через WebSocket:', data);
          this.listeners.forEach(cb => cb(data));
        } catch (e) {
          console.error('❌ Ошибка парсинга WebSocket сообщения:', e);
        }
      };

      this.socket.onclose = (event) => {
        console.log('🔌 WebSocket отключен. Код:', event.code, 'Причина:', event.reason);
        this.tryReconnect();
      };

      this.socket.onerror = (error) => {
        console.error('❌ WebSocket ошибка:', error);
      };
    } catch (error) {
      console.error('❌ Ошибка подключения WebSocket:', error);
      this.tryReconnect();
    }
  }

  tryReconnect() {
    if (this.reconnectAttempts < this.maxReconnectAttempts && this.username) {
      this.reconnectAttempts++;
      const delay = Math.min(1000 * Math.pow(2, this.reconnectAttempts), 30000);
      console.log(`🔄 Попытка переподключения через ${delay}мс (${this.reconnectAttempts}/${this.maxReconnectAttempts})`);
      setTimeout(() => {
        if (!this.socket || this.socket.readyState === WebSocket.CLOSED) {
          this.connect(this.username);
        }
      }, delay);
    } else {
      console.error('❌ Не удалось переподключиться WebSocket после нескольких попыток');
    }
  }

  onMessage(callback) {
    this.listeners.push(callback);
  }

  send(data) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(data));
      console.log('📤 Отправлено через WebSocket:', data);
    } else {
      console.warn('⚠️ WebSocket не открыт, сообщение не отправлено. Статус:', this.socket?.readyState);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
    this.listeners = [];
    this.reconnectAttempts = 0;
    this.username = null;
  }
}

export default new WebSocketService();